const roundOff = (num: number, places: number) => {
  const x = 10 ** places;
  return Math.round(num * x) / x;
};

// eslint-disable-next-line import/prefer-default-export
export { roundOff };
